"use strict";
;
(function() {
    var SocialShareService = (function(){
        var SocialShareService = function(facebookAppId, facebookAppScope, googleClientId) {
            this.facebookAppId = facebookAppId;
            this.facebookAppScope = facebookAppScope;
            this.googleClientId = googleClientId;
        };

        SocialShareService.prototype.getFacebookReach =function() {
            return new Promise(function(resolve, reject) {
            FB.api('/me/friends', function(me) {
                var friends = (me.summary || {}).total_count || 0;
                resolve(friends);
            });
            });
        };
    
        SocialShareService.prototype.checkFacebookPermission = function () {
          var service = this;
          return new Promise(function (resolve, reject) {
            FB.getLoginStatus(function (fbResponse) {
              if (fbResponse.status === 'connected') {
                // https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus/
                // the user is logged in and has authenticated your
                // app, and response.authResponse supplies
                // the user's ID, a valid access token, a signed
                // request, and the time the access token
                // and signed request each expire
                resolve(fbResponse.authResponse);
              } else {
                reject('Facebook not connected');
              }
            }, true);
          });
        };

        SocialShareService.prototype.facebookShare = function(channel, sampleKit, shareUrl, shareType, shareModel) {
            if (dataLayer) {
              dataLayer.push({
                event: 'share_product_click',
                parameter: {
                  provider: 'facebook',
                  samplekit: sampleKit && sampleKit.name,
                }
              })
            }
            console.log('sharing on facebook');
            return new Promise(function(resolve, reject) {
                FB.ui({
                    method: 'share',
                    href: shareUrl,
                    quote: (sampleKit || {}).message,
                    display: 'popup'
                }, function(response) {
                    if ( console && console.log ) console.log('FB Share response', response);
                    // if response is undefined, a user didn't share the link.
                    if (response) {
                        switch (shareType) {
                        case 'friend-referral':
                            window.snTrackEventsModule.trackEvent('', 'Friend Referral Share', 'Facebook', '' );
                            return;
                        case 'review' :
                            window.snTrackEventsModule.trackEvent(sampleKit.Id, 'Review Share', 'Facebook', sampleKit.name );
                            return;
                        default: 
                            window.snTrackEventsModule.trackEvent(sampleKit.Id, 'Product Share', 'Facebook', sampleKit.name );
                            return resolve({
                                Channel: 'facebook',
                                SampleKitId: sampleKit.Id,
                                AccessToken: '',
                                SocialId: '',
                                Message: '',
                                PostId: '',
                                Reach: 0,
                                PostLink: '',
                            });
                        }
                    }
                });
            });
        };

        SocialShareService.prototype.doShare = function(sender, channel, shareUrl, shareType, shareModel, sampleKit) {
            var handleCallback = function(shareData) {
                shareData.SampleKitId = shareModel;
                $.post('/product/socialpost', shareData);
            };
            switch ( channel ) {
            case 'facebook':
                this.facebookShare(channel, sampleKit, shareUrl, shareType, shareModel).then(handleCallback);
                break;
          };
        };

        return SocialShareService;
    })();

    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = SocialShareService;
    } else {
        window.SocialShareService = SocialShareService;
    }
})();
